import { render, staticRenderFns } from "./Pontuacao.vue?vue&type=template&id=6eacadba"
import script from "./Pontuacao.vue?vue&type=script&lang=js"
export * from "./Pontuacao.vue?vue&type=script&lang=js"
import style0 from "./Pontuacao.vue?vue&type=style&index=0&id=6eacadba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports